
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSendOTP, useUserCreate, useVerifyOtp } from './api';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate, useParams } from 'react-router-dom';
import code from './code.json'
import { useTranslation } from 'react-i18next';
import { generateSecureRandomNumber } from '../../utils/randomString';
import { SplineIcon } from 'lucide-react';
import { Dots } from '../../lib/Dots'
import { Timer } from '../../lib/expireTime';
import { useToast } from '../../hook/usetoast';
const Register = (props) => {
    const toast = useToast()

    const { t } = useTranslation();
    const validationSchema = Yup.object({
        name: Yup.string().required(t("Name is required")).matches(/^[A-Za-z\s]+$/, t("Name must only contain letters and spaces")).min(3, t("Name must be at least 3 characters"))
            .max(20, t("Name must be at most 20 characters")),
        // email: Yup.string().required(t("Email is required")).email(t("Invalid email format")).matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]+\.[a-zA-Z]{2,}$/, t("Invalid email format"))
        //     .matches(/@([a-zA-Z.-]+)$/, t("Email domain must not contain numbers after @")),
        email: Yup.string()
            .required(t("Email is required"))
            .email(t("Invalid email format"))
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                t("Invalid email format")
            )
            .matches(
                /@([a-zA-Z0-9.-]+)$/,
                t("Email domain can contain numbers after '@'")
            ),

        mobileCode: Yup.string()  // Change from number to string
            .required(t("Mobile code is required")),
        phoneNumber: Yup.string()
            .required(t("Phone number is required")),
        otp: Yup.string(),
        password: Yup.string()
            .required(t("Password is required"))
            .min(6, t("Password must be at least 6 characters"))
            .matches(/[A-Z]/, t("Password must contain at least one capital letter"))
            .matches(/\d/, t("Password must contain at least one number"))
            .matches(/[^A-Za-z0-9]/, t("Password must contain at least one special character")),
        confirmPassword: Yup.string()
            .required(t("Confirm password is required"))
            .oneOf([Yup.ref('password'), null], t("Passwords must match")),
        referralCode: Yup.string(),
        agreeToTerms: Yup.bool().oneOf([true], t("You must accept the terms and conditions")).required(),
        recaptcha: Yup.string().required(t("reCAPTCHA verification is required")),

    });

    const { register, control, handleSubmit, formState: { errors }, reset, setError, getValues } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            mobileCode: "234",
            otp: ""
        }
    });
    const { id } = useParams()

    const { isloading, setIsloading } = useModalContext();
    const recaptchaRef = useRef();
    const navigate = useNavigate()

    const userCreate = useUserCreate()
    const [showPassword, setShowPassword] = useState("password");
    const [showCPassword, setShowCPassword] = useState("password");
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [waitingTime, setWaitingTime] = useState(false);
    console.log("🦄 waitingTime", waitingTime);

    const [mobileComplete, setMobileComplete] = useState(false);
    const [phoneOTP, setPhoneOTP] = useState("");


    const handleShowPassword = (name) => {
        if (name == "psw") {
            const ptype = showPassword === "text" ? "password" : "text";
            setShowPassword(ptype);
        } else if (name == "cpsw") {
            const ptype1 = showCPassword === "text" ? "password" : "text";
            setShowCPassword(ptype1);
        }
    };

    useEffect(() => {
        let interval = setTimeout(() => {
            setWaitingTime(false);
        }, 60000);

        return () => {
            clearInterval(interval);
        };
    }, [waitingTime])

    const [randomData, setRandomData] = useState(Math.floor(100000 + generateSecureRandomNumber() * 900000))
    const sendmutation = useSendOTP()
    const verifyOTPmutation = useVerifyOtp()



    const sendPhoneOTP = async (name, email, phoneNumber, code) => {
        if (name == '' || email == '' || phoneNumber === undefined) {
            toast.error("Fields are required")
            return
        }

        const emailSchema = Yup.string()
            .required(t("Email is required"))
            .email(t("Invalid email format"))
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                t("Invalid email format")
            )
            .matches(
                /@([a-zA-Z0-9.-]+)$/,
                t("Email domain can contain numbers after '@'")
            )

        try {
            emailSchema.validateSync(email);
        } catch (error) {
            toast.error(error.message);
            return;
        }

        // Proceed with OTP sending if validation passes
        let obj = {
            "name": name,
            "email": email,
            "phoneNumber": phoneNumber,
            "countryCode": code
        }

        let res = await sendmutation.mutateAsync(obj)

        if (res?.status) {
            setMobileComplete(true)
            setWaitingTime(true)
        }
    }

    const verifyphoneOTP = async (e, email) => {
    console.log("🦁 ~ verifyphoneOTP ~ email:", email)

          if (e.key === "Enter" || e.nativeEvent.pointerType === "mouse" || e.nativeEvent.pointerType === "touch") {
            let obj = {
                "email": email,
                "OTP": phoneOTP,
            }

            if (!phoneOTP) {
                return setError("otp", { message: "OTP is required" })
            } else if (phoneOTP.length <= 4) {
                return setError("otp", { message: "Invalid OTP" })
            }



            let res = await verifyOTPmutation.mutateAsync(obj)
            if (res?.status) {
                setIsPhoneVerified(true);
                setWaitingTime(false)
            } else setPhoneOTP('')
        }
    }

    const onSubmit = async (data) => {



        setIsloading(true)

        try {
            const userData = {
                name: data.name,
                email: data.email,
                phoneNumber: data.phoneNumber,
                password: data.password,
                confirmPassword: data.confirmPassword,
                referralCode: data.referralCode,
                agreeToTerms: data.agreeToTerms,
                recaptcha: data?.recaptcha,
                randomId: randomData,
                countryCode: data.mobileCode


            }
            const res = await userCreate.mutateAsync(userData)
            if (res?.status) {
                reset({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    password: "",
                    confirmPassword: "",
                    referralCode: "",
                })
                setIsloading(false)
                setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                navigate('/')
            }

        } catch (error) {
            setIsloading(false)

        } finally {
            setIsloading(false)
        }
    };



    function getPhoneVerificationDisplay() {
        if (isPhoneVerified) {
            return <span className='yellowTxt'>verified</span>;
        } else if (isloading) {
            return <span className="yellowTxt"><Dots>Sending</Dots></span>;
        } else if (waitingTime) {
            return <span className="yellowTxt"><Timer /></span>;
        } else {
            // Render the resend/send button with appropriate accessibility enhancements
            return (
                <button
                    className="yellowTxt"
                  
                    onClick={() => sendPhoneOTP(getValues('name'), getValues('email'), getValues('phoneNumber'), getValues('mobileCode'))}
              
                >
                    {mobileComplete ? "Re-send" : "Send OTP"}
                </button>
            );
        }
    }

    return (
        <>
            {isloading && <Loader />}
            <div className="AuthPg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-lg-8">
                            <div className="AuthBgFrm">
                                <h3>{t('Sign up')}</h3>
                                <p>{t('Create New KKOG Blockchain Account')}</p>
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Your Name")}
                                            {...register('name')}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                            }}
                                        />
                                        {errors.name && <p className="text-danger">{errors.name.message}</p>}

                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Your Email")}
                                            {...register('email')}
                                        />
                                        {errors.email && <p className="text-danger">{errors.email.message}</p>}

                                    </div>
                                    <div className="form-group">



                                        <div className='nji_ki mb-3'>
                                            <Controller
                                                name="mobileCode"
                                                control={control}
                                                render={({ field }) => (
                                                    <select
                                                        {...field}
                                                        id="mobileCode"
                                                        defaultValue={"+234"}
                                                        className="custom-select  form-control"
                                                        value={field.value || "+234"}
                                                        onChange={(e) => field.onChange(e.target.value)}
                                                    >
                                                        {code?.map((dial, index) => (
                                                            <option key={index || dial._id} value={dial?.dial_code.replace('+', '')}>
                                                                {dial?.emoji} {dial?.dial_code}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                            />


                                            <Controller
                                                name="phoneNumber"
                                                control={control}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        id="yrNm"
                                                        className="form-control"
                                                        placeholder={t("Enter mobile number")}
                                                        maxLength={15}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            if (value.length <= 15) {
                                                                field.onChange(value);
                                                            }
                                                        }}
                                                        disabled={isPhoneVerified || waitingTime}

                                                    />
                                                )}
                                            />
                                       

<span className='nji_kiTxt'>
    {getPhoneVerificationDisplay()}
</span>
                                        </div>
                                        {errors.phoneNumber && <p className="text-danger">{errors.phoneNumber.message}</p>}

                                    </div>
                                    {waitingTime &&
                                        <div className="form-group">
                                            <div className='nji_ki mb-3'>

                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    maxLength={6}
                                                    value={phoneOTP}
                                                    disabled={!mobileComplete || isPhoneVerified}
                                                    onChange={(e) => setPhoneOTP(e.target.value)}
                                                    onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                                    id="phoneOTP"
                                                    placeholder="Enter your Mobile OTP"
                                                />
                                                <span className='nji_kiTxt'>
                                                    {isPhoneVerified ?
                                                        <span className='nji_kiTxt'>
                                                            Verified
                                                        </span>
                                                        :
                                                        <button
                                                        className="input-group-text yellowTxt"
                                                        tabIndex={0}
                                                        aria-disabled={verifyOTPmutation.isLoading} 
                                                        onClick={(e) => !verifyOTPmutation.isLoading && verifyphoneOTP(e, getValues('email'))}
                                                        onKeyDown={(e) => {
                                                            if (!verifyOTPmutation.isLoading && (e.key === 'Enter' || e.key === ' ')) {
                                                                verifyphoneOTP(e, getValues('email'));
                                                            }
                                                        }}

                                                      
                                                    >
                                                        {verifyOTPmutation.isLoading ? <SplineIcon /> : "Verify"}
                                                    </button>
                                                    }
                                                </span>

                                            </div>
                                            {errors.otp && <p className="text-danger">* {errors.otp.message}</p>}
                                        </div>}


{isPhoneVerified ? 
<>
                                    <div className="form-group">
                                        <input
                                            type={showPassword}
                                            className="form-control"
                                            placeholder={t("Password")}
                                            {...register('password')}
                                        />
                                        <span >
                                            <button
                                                type="button"
                                                className="InputIcon EpySty eyeslsIg"
                                                name="psw"
                                                onClick={() => handleShowPassword("psw")}
                                            >
                                                {showPassword === "password" ? (


                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.3">
                                                            <path d="M21.2699 9.17999C20.9799 8.71999 20.6699 8.28999 20.3499 7.88999C19.9799 7.41999 19.2799 7.37999 18.8599 7.79999L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85C10.8099 15.85 9.37995 17.28 8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.17999Z" fill="#121212" />
                                                            <path d="M14.0201 9.98001L9.98014 14.02C9.47014 13.5 9.14014 12.78 9.14014 12C9.14014 10.43 10.4201 9.14001 12.0001 9.14001C12.7801 9.14001 13.5001 9.47001 14.0201 9.98001Z" fill="#121212" />
                                                            <path d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z" fill="#121212" />
                                                            <path d="M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z" fill="white" />
                                                            <path d="M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z" fill="white" />
                                                        </g>
                                                    </svg>
                                                ) : (

                                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.3" clipPath="url(#clip0_2002_6031)">
                                                            <path d="M19.25 6.14993C16.94 2.51993 13.56 0.429932 10 0.429932C8.22 0.429932 6.49 0.949937 4.91 1.91994C3.33 2.89994 1.91 4.32993 0.75 6.14993C-0.25 7.71993 -0.25 10.2699 0.75 11.8399C3.06 15.4799 6.44 17.5599 10 17.5599C11.78 17.5599 13.51 17.0399 15.09 16.0699C16.67 15.0899 18.09 13.6599 19.25 11.8399C20.25 10.2799 20.25 7.71993 19.25 6.14993ZM10 13.0399C7.76 13.0399 5.96 11.2299 5.96 8.99994C5.96 6.76994 7.76 4.95995 10 4.95995C12.24 4.95995 14.04 6.76994 14.04 8.99994C14.04 11.2299 12.24 13.0399 10 13.0399Z" fill="#121212" />
                                                            <path d="M10.0004 6.14001C8.43039 6.14001 7.15039 7.42002 7.15039 9.00002C7.15039 10.57 8.43039 11.85 10.0004 11.85C11.5704 11.85 12.8604 10.57 12.8604 9.00002C12.8604 7.43002 11.5704 6.14001 10.0004 6.14001Z" fill="white" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2002_6031">
                                                                <rect width="20" height="18" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                )}
                                            </button>
                                        </span>
                                        {errors.password && <p className="text-danger">{errors.password.message}</p>}

                                    </div>
                                    <div className="form-group">
                                        <input
                                            type={showCPassword}
                                            className="form-control"
                                            placeholder={t("Confirm Password")}
                                            {...register('confirmPassword')}
                                        />
                                        <span >
                                            <button
                                                type="button"
                                                className="InputIcon EpySty eyeslsIg"
                                                name="psw"
                                                onClick={() => handleShowPassword("cpsw")}
                                            >
                                                {showCPassword === "password" ? (

                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.3">
                                                            <path d="M21.2699 9.17999C20.9799 8.71999 20.6699 8.28999 20.3499 7.88999C19.9799 7.41999 19.2799 7.37999 18.8599 7.79999L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85C10.8099 15.85 9.37995 17.28 8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.17999Z" fill="#121212" />
                                                            <path d="M14.0201 9.98001L9.98014 14.02C9.47014 13.5 9.14014 12.78 9.14014 12C9.14014 10.43 10.4201 9.14001 12.0001 9.14001C12.7801 9.14001 13.5001 9.47001 14.0201 9.98001Z" fill="#121212" />
                                                            <path d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z" fill="#121212" />
                                                            <path d="M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z" fill="white" />
                                                            <path d="M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z" fill="white" />
                                                        </g>
                                                    </svg>
                                                ) : (


                                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.3" clipPath="url(#clip0_2002_6031)">
                                                            <path d="M19.25 6.14993C16.94 2.51993 13.56 0.429932 10 0.429932C8.22 0.429932 6.49 0.949937 4.91 1.91994C3.33 2.89994 1.91 4.32993 0.75 6.14993C-0.25 7.71993 -0.25 10.2699 0.75 11.8399C3.06 15.4799 6.44 17.5599 10 17.5599C11.78 17.5599 13.51 17.0399 15.09 16.0699C16.67 15.0899 18.09 13.6599 19.25 11.8399C20.25 10.2799 20.25 7.71993 19.25 6.14993ZM10 13.0399C7.76 13.0399 5.96 11.2299 5.96 8.99994C5.96 6.76994 7.76 4.95995 10 4.95995C12.24 4.95995 14.04 6.76994 14.04 8.99994C14.04 11.2299 12.24 13.0399 10 13.0399Z" fill="#121212" />
                                                            <path d="M10.0004 6.14001C8.43039 6.14001 7.15039 7.42002 7.15039 9.00002C7.15039 10.57 8.43039 11.85 10.0004 11.85C11.5704 11.85 12.8604 10.57 12.8604 9.00002C12.8604 7.43002 11.5704 6.14001 10.0004 6.14001Z" fill="white" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2002_6031">
                                                                <rect width="20" height="18" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                )}
                                            </button>
                                        </span>
                                        {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}

                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Referral Code")}
                                            {...register('referralCode')}
                                            value={id}
                                            readOnly
                                        />
                                        {errors.referralCode && <p className="text-danger">{errors.referralCode.message}</p>}

                                    </div>
                                    <div className="form-group">
                                        <div className="RemPwdChk">
                                            <label className="CustChkBxContainer">
                                                {t('I agree to the')} <a href="/">{t('Terms & Conditions')}</a> {t('and')} <a href="/">{t('Privacy Policy')}</a>
                                                <input type="checkbox" {...register('agreeToTerms')} />
                                                <span className="CustChkMrk"></span>
                                            </label>
                                            {errors.agreeToTerms && <p className="text-danger">{errors.agreeToTerms.message}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <Controller name='recaptcha' control={control} render={({ field }) => (
                                            <ReCAPTCHA
                                                {...field}
                                                ref={recaptchaRef}
                                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}

                                            />
                                        )} />
                                        {errors.recaptcha && <p className="text-danger">{errors.recaptcha.message}</p>}

                                    </div>
                                    <div className="form-group">
                                        <button className='btn CmnBtn w-100 h-46' disabled={!isPhoneVerified}>{t('Create Account')}</button>
                                    </div>
                                    </>
: ""}

                                    <div className="form-group">
                                        <h6 className='text-center'>{t('Already have an account?')} <a href='/login'>{t('Sign in here')}</a></h6>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Register;





